import React from 'react';
import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { SelectDropdown, SelectDropdownOption } from 'components/UI/V3/SelectDropdown/SelectDropdown';

export type ClientView = 'all' | 'clients' | 'booked_leads';

interface ClientViewFilterProps {
    value: ClientView;
    onChange: (value: ClientView) => void;
}

const VIEW_OPTIONS: Array<SelectDropdownOption<ClientView>> = [
    { id: 'all', label: 'All' },
    { id: 'clients', label: 'Clients' },
    { id: 'booked_leads', label: 'Booked Leads' }
];

const ClientViewFilter: React.FC<ClientViewFilterProps> = ({ value, onChange }) => {
    const selectedOption = React.useMemo(() => VIEW_OPTIONS.find(option => option.id === value) ?? null, [value]);

    const changeHandler = (option: SelectDropdownOption<ClientView> | null) => {
        if (option) {
            onChange(option.id);
        }
    };

    return (
        <SelectDropdown<ClientView>
            options={VIEW_OPTIONS}
            value={selectedOption}
            onChange={changeHandler}
            buttonProps={{ 'variant': 'outlined', 'leftIcon': faUsers, 'aria-label': 'Clients view filter' }}
        />
    );
};

export default ClientViewFilter;
